module.exports = __webpack_public_path__ + "static/media/drink.7a32930e.jpg";